const app = JSON.parse(localStorage.getItem("app")) || {
  osType: "",
  osInfo: "",
  imei: "",
  udid: "",
  sdkVersion: "",
  agent: "",
  appId: "",
  gameId: "",
};
app.altUsername = undefined;

const user = JSON.parse(localStorage.getItem("user")) || {};

export default {
  native: true,
  app: app,
  setApp() {
    let app = { ...this.app };
    app.altUsername = undefined;
    localStorage.setItem("app", JSON.stringify(app));
  },
  user: user,
  setUser() {
    let user = { ...this.user };
    localStorage.setItem("user", JSON.stringify(user));
  },
};
